import styled from 'styled-components'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import { IItem } from '.'

const statusOptions = {
  incomplete: {
    backgroundColor: colors.neutralColorHighDark,
    borderColor: colors.neutralColorHighDark,
    labelColor: colors.neutralColorLowMedium,
    lineColor: colors.neutralColorHighDark,
  },
  complete: {
    backgroundColor: colors.feedbackColorPositivePure,
    borderColor: colors.feedbackColorPositivePure,
    lineColor: colors.feedbackColorPositivePure,
    labelColor: colors.feedbackColorPositivePure,
  },
  'in-progress': {
    backgroundColor: colors.neutralColorHighPure,
    borderColor: colors.feedbackColorPositivePure,
    labelColor: colors.neutralColorLowPure,
    lineColor: colors.neutralColorHighDark,
  },
  negative: {
    backgroundColor: colors.neutralColorHighPure,
    borderColor: colors.feedbackColorNegativePure,
    labelColor: colors.feedbackColorNegativePure,
    lineColor: colors.neutralColorHighDark,
  },
}

export const Wrapper = styled.ul`
  display: flex;
  justify-content: space-between;
  padding: 0;
`

export const Item = styled.li<{ status: IItem['status'] }>`
  flex-basis: 0;
  flex-grow: 1;
  flex: 1 1 0;
  list-style: none;
  padding-bottom: 1.3rem;
  position: relative;
  text-align: center;
  color: ${(props) => statusOptions[props.status].labelColor};
  font-family: ${fonts.inter};
  font-style: normal;
  font-weight: normal;
  font-size: 1.4rem;
  line-height: 150%;

  &::before {
    background-color: ${(props) => statusOptions[props.status].backgroundColor};
    border: 0.2rem solid;
    border-color: ${(props) => statusOptions[props.status].borderColor};
    border-radius: 1em;
    bottom: -0.5rem;
    content: ' ';
    display: block;
    height: 0.8rem;
    left: 50%;
    position: absolute;
    width: 0.8rem;
    z-index: 2;
  }

  &:not(:last-child):after {
    background-color: ${(props) => statusOptions[props.status].lineColor};
    bottom: 0;
    content: ' ';
    display: block;
    height: 0.2rem;
    left: 50%;
    position: absolute;
    width: 100%;
    z-index: 1;
  }
`
